import {Component, OnInit} from '@angular/core';
import {Gn1DialogComponent} from './dialogs/gn1-dialog/gn1-dialog.component';
import {AnnuityService} from '../services/annuity.service';
import {MemberService} from '../services/member.service';
import {SubcategoryService} from '../services/subcategory.service';


import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';
import { of as observableOf } from 'rxjs';
import { FlatTreeControl } from '@angular/cdk/tree';


/** File node data with nested structure. */
export interface FileNode {
  name: string;
  type: string;
  children?: FileNode[];
}

/** Flat node with expandable and level information */
export interface TreeNode {
  name: string;
  type: string;
  level: number;
  expandable: boolean;
}

@Component({
  selector: 'app-gn1',
  templateUrl: './gn1.component.html',
  styleUrls: [ './gn1.component.scss' ],
  entryComponents: [
    Gn1DialogComponent
  ]
})

export class Gn1Component implements OnInit {

  /** The TreeControl controls the expand/collapse state of tree nodes.  */
  treeControl: FlatTreeControl<TreeNode>;
  /** The TreeFlattener is used to generate the flat list of items from hierarchical data. */
  treeFlattener: MatTreeFlattener<FileNode, TreeNode>;
  /** The MatTreeFlatDataSource connects the control and flattener to provide data. */
  dataSource: MatTreeFlatDataSource<FileNode, TreeNode>;

  public errors = []
  public members = []
  public fileReaded: any;
  public sbccvMembers: any[] = []
  public gn1Members: any[] = []
  public subCategories = []
  public sbccvLoaded: boolean = false;

  constructor (
    public _annuityService: AnnuityService,
    public _memberService: MemberService,
    public _subCategoryService: SubcategoryService) {

    this.treeFlattener = new MatTreeFlattener(
      this.transformer,
      this.getLevel,
      this.isExpandable,
      this.getChildren);

    this.treeControl = new FlatTreeControl<TreeNode>(this.getLevel, this.isExpandable);
    this.dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);
    this.dataSource.data = this.getData();

  }

  ngOnInit () { }

  ngOnDestroy () { }

  transformer (node: FileNode, level: number) {
    return {
      name: node.name,
      type: node.type,
      level: level,
      expandable: !!node.children
    };
  }

  /** Get the level of the node */
  getLevel (node: TreeNode) {
    return node.level;
  }

  /** Return whether the node is expanded or not. */
  isExpandable (node: TreeNode) {
    return node.expandable;
  };

  /** Get the children for the node. */
  getChildren (node: FileNode) {
    return observableOf(node.children);
  }

  /** Get whether the node has children or not. */
  hasChild (index: number, node: TreeNode) {
    return node.expandable;
  }

  getData(): any[] {

    const files =  [
      {
        name: 'material2',
        type: 'folder',
        children: [
          {
            name: 'src',
            type: 'folder',
            children: [
              {
                name: 'cdk',
                children: [
                  {name: 'package.json', type: 'file'},
                  {name: 'BUILD.bazel', type: 'file'},
                ]  
              },
              {name: 'lib', type: 'folder'}
            ]
          }
        ]
      },
      {
        name: 'angular',
        type: 'folder',
        children: [
          {
            name: 'packages',
            type: 'folder',
            children: [
              {name: '.travis.yml', type: 'file'},
              {name: 'firebase.json', type: 'file'}
            ]
          },
          {name: 'package.json', type: 'file'}
        ]
      },
      {
        name: 'angularjs',
        type: 'folder',
        children: [
          {name: 'gulpfile.js', type: 'file'},
          {name: 'README.md', type: 'file'}
        ]
      }
    ]

    return files
  }

}